import axios from '../utils/axios'

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const getAppointment = (clinicId, date = 'today') =>
    axios.get(`${API_URL}clinics/${clinicId}/dashboard-appointments?date=${date}`);

const getDashboardStats = (clinicId) =>
    axios.get(`${API_URL}clinics/${clinicId}/dashboard-stats`);

const dashboardService = {
    getAppointment,
    getDashboardStats,
};

export default dashboardService;
